import useGetVaults from '@/services/api/vault/useGetVaults.js'
import { DataTable } from './DataTable'
import _ from 'lodash'
// import MyTable from './MyTable'
import {
  useReactTable,
  getCoreRowModel,
  createColumnHelper,
  getExpandedRowModel,
} from '@tanstack/react-table'
import { useCallback, useEffect, useMemo } from 'react'
import useGetPeriodColumns from '@/services/api/cash-flow/useGetPeriodColumns.js'
import {
  ArchiveBoxIcon,
  ArrowDownRightIcon,
  ArrowUpRightIcon,
  ChevronDownIcon,
  ChevronRightIcon,
  CurrencyDollarIcon,
  EllipsisHorizontalIcon,
  FolderIcon,
  FolderPlusIcon,
  PencilSquareIcon,
  PlayIcon,
  PlusCircleIcon,
  FlagIcon,
  ArrowsUpDownIcon,
} from '@heroicons/react/16/solid'
import { Button, ButtonText } from '@/components/ui/button'

import PropTypes from 'prop-types'
import { cn } from '@/lib/utils'
import {
  DropdownMenu,
  DropdownMenuContent,
  DropdownMenuItem,
  DropdownMenuPortal,
  DropdownMenuSub,
  DropdownMenuSubContent,
  DropdownMenuSubTrigger,
  DropdownMenuTrigger,
} from '@/components/ui/DropdownMenu'
import useGetTransactions from '@/services/api/cash-flow/transaction/useGetTransactions.js'
import useGetIncomeCategories from '@/services/api/transaction-category/useGetIncomeCategories.js'
import useGetExpenseCategories from '@/services/api/transaction-category/useGetExpenseCategories.js'
import { formatDate } from 'date-fns'
import useNumberFormatter from '@/hooks/useNumberFormatter'
import {
  ENTITY_TYPES,
  TRANSACTION_DIRECTION,
  TRANSACTION_TYPES,
  MODAL_WINDOW_TYPE,
} from '@/data/constants/constants'
import useAppStore from '@/store/useAppStore'
import ConditionalRender from '@/components/ui/ConditionalRender'
import useOpenNonModalWndow from '@/hooks/useOpenNonModalWndow'
import useOpenModalWindow from '@/hooks/useOpenModalWndow'
import useGetPrearchiveVault from '@/services/api/vault/useGetPrearchiveVault.js'
import useGetIsEmptyCategory from '@/services/api/transaction-category/useGetIsEmptyCategory.js'
import useMarkDefaultForIncome from '@/services/api/vault/useMarkDefaultForIncome.js'
import useMarkDefaultForExpense from '@/services/api/vault/useMarkDefaultForExpense.js'
import { useNavigate } from 'react-router-dom'
import TruncatedLabel from '@/components/ui/TruncatedLabel'
import UnArchiveTransactionCatrgory from './UnArchiveTransactionCatrgory'
import UnArchiveVault from './UnArchiveVault'
import ArchiveEmptyCategory from '@/components/transactionCategory/ArchiveEmptyCategory'
import ClickableCell from './ClickableCell'

function ColumnHeader({ children, className, ...rest }) {
  return (
    <div
      className={cn(['tw-font-medium tw-text-primary'], className)}
      {...rest}
    >
      {children}
    </div>
  )
}

ColumnHeader.propTypes = {
  children: PropTypes.node.isRequired,
  className: PropTypes.string,
}

ColumnHeader.propTypes = {
  children: PropTypes.node.isRequired,
}

export default function TransactionTable() {
  const formatter = useNumberFormatter({
    // style: 'currency',
    // currency: 'AUD',
    // locale: 'ja-JP',
  })

  const navigate = useNavigate()
  const { openModal } = useOpenModalWindow()
  const { open } = useOpenNonModalWndow()

  const setEditedEntity = useAppStore((state) => state.setEditedEntity)
  const setArchivedVault = useAppStore((state) => state.setArchivedVault)
  const archivedVault = useAppStore((state) => state.archivedVault)
  const archivedEntity = useAppStore((state) => state.archivedEntity)
  // const setArchivedEntity = useAppStore((state) => state.setArchivedEntity)
  const { data: prearchiveVault } = useGetPrearchiveVault(archivedVault?.id)
  const { data: isEmptyCategory } = useGetIsEmptyCategory(archivedEntity?.id)
  const { data: vaults } = useGetVaults()
  const { mutate: markDefaultForIncome } = useMarkDefaultForIncome()
  const { mutate: markDefaultForExpense } = useMarkDefaultForExpense()

  const vaultsFlat = _.flatten(
    vaults?.map((vault) => {
      return vault.is_group ? vault.vaults : [vault]
    }),
  )

  const onArchiveVault = (original) => {
    setArchivedVault(original)
  }

  useEffect(() => {
    if (prearchiveVault) {
      if (vaultsFlat.length > 1) {
        if (
          prearchiveVault?.can_delete &&
          !(
            prearchiveVault?.requires_expense_default ||
            prearchiveVault?.requires_income_default
          )
        ) {
          openModal({ name: MODAL_WINDOW_TYPE.EMPTY_VAULT_ARCHIVE })
        } else {
          openModal({ name: MODAL_WINDOW_TYPE.ARCHIVE_VAULT })
        }
      } else {
        openModal({ name: MODAL_WINDOW_TYPE.UNABLE_TO_ARCHIVE })
      }
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [prearchiveVault])

  // const onArchiveCategory = (original) => {
  //   setArchivedEntity(original)
  // }

  useEffect(() => {
    if (archivedEntity) {
      if (!isEmptyCategory?.is_empty) {
        openModal({ name: MODAL_WINDOW_TYPE.ARCHIVE_CATEGORY })
      } else {
        openModal({ name: MODAL_WINDOW_TYPE.ARCHIVE_EMPTY_CATEGORY })
      }
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [isEmptyCategory])

  const onEdit = (original) => {
    // TODO:Refactor to use URL ids instead of setEditedEntity
    setEditedEntity(original)
    if (
      original.entity_type === 'transaction_category' &&
      original.direction === 1
    ) {
      // setEdited FIxed
      return navigate(`/categories/${original?.id}/edit?type=in`)
      // return NON_MODAL_WINDOW_TYPE.EDIT_INCOME
    } else if (
      original.entity_type === 'transaction_category' &&
      original.direction === -1
    ) {
      return navigate(`/categories/${original?.id}/edit?type=out`)
      // return NON_MODAL_WINDOW_TYPE.EDIT_EXPENSE
    } else if (original.entity_type === 'vault') {
      return navigate(`vaults/${original?.id}/edit`)
      // return NON_MODAL_WINDOW_TYPE.EDIT_VAULT
    } else if (
      original.entity_type === 'transaction_category_group' ||
      original.entity_type === 'vault_group'
    ) {
      return navigate(`groups/${original?.id}/edit`)
      // return NON_MODAL_WINDOW_TYPE.EDIT_GROUP
    }
  }

  const periodType = useAppStore((state) => state.periodType)
  const offset = useAppStore((state) => state.offset)
  const numberOfPeriods = useAppStore((state) => state.numberOfPeriods)

  // const setOffset = useAppStore((state) => state.setOffset)
  // const setNumberOfPeriods = useAppStore((state) => state.setNumberOfPeriods)

  // const [numberOfPeriods, setNumberOfPeriods] = useState(16)
  const { data: vaultsData, status } = useGetVaults({
    offset,
    numberOfPeriods,
    periodType,
  })
  const { data: periodColumns, status: periodColumnsStatus } =
    useGetPeriodColumns({ numberOfPeriods, offset, periodType })

  const { data: transactions, status: transactionStatus } = useGetTransactions({
    offset,
    numberOfPeriods,
    periodType,
  })

  const { data: incomeCategories, status: incomeCategoriesStatus } =
    useGetIncomeCategories()
  const { data: expenseCategories, status: expenseCategoriesStatus } =
    useGetExpenseCategories()

  // const rows = useMemo(() => {
  //   if (status !== 'success') return []
  //   const result = [...dataorg]
  //   result?.push({ id: 1, name: 'My Moneyxxx' })
  //   return result
  // }, [dataorg, status])

  //   const columns = [
  //     {
  //       Header: 'ID',
  //     },
  //   ]

  const vaultBalance = useMemo(() => {
    const _vaultBalance = []
    if (status !== 'success' || transactionStatus !== 'success') return []
    const rows = [...vaultsData]
    const allOffsets = periodColumns?.map((col) => col.offset) || []
    rows.forEach((item) => {
      if (item.is_group) {
        item.vaults.forEach((vault) => {
          const { id, vault_group_id } = vault
          allOffsets.forEach((offset) => {
            const sum = transactions.reduce(
              (acc, transaction) => {
                if (
                  transaction.offset === offset &&
                  transaction.vault_id === id
                ) {
                  return acc + transaction.signed_amount
                }
                return acc
              },
              vault.offset === offset ? vault.initial_balance : 0,
            )
            const existingVault = _vaultBalance.find(
              (v) => v.vaultId === id && v.offset === offset,
            )
            if (existingVault) {
              existingVault.amount += sum
            } else {
              _vaultBalance.push({
                vaultId: id,
                offset,
                amount: sum,
                vaultGroupId: vault_group_id,
              })
            }
          })
        })
      } else {
        const { id, vault_group_id } = item
        allOffsets.forEach((offset) => {
          const sum = transactions.reduce(
            (acc, transaction) => {
              if (
                transaction.offset === offset &&
                transaction.vault_id === id
              ) {
                return acc + transaction.signed_amount
              }
              return acc
            },
            item.offset === offset ? item.initial_balance : 0,
          )
          const existingVault = _vaultBalance.find(
            (v) => v.vaultId === id && v.offset === offset,
          )
          if (existingVault) {
            existingVault.amount += sum
          } else {
            _vaultBalance.push({
              vaultId: id,
              offset,
              amount: sum,
              vaultGroupId: vault_group_id,
            })
          }
        })
      }
    })
    return _vaultBalance
  }, [vaultsData, transactions, status, transactionStatus, periodColumns])

  const data = useMemo(() => {
    if (
      status !== 'success' ||
      transactionStatus !== 'success' ||
      periodColumnsStatus !== 'success' ||
      incomeCategoriesStatus !== 'success' ||
      expenseCategoriesStatus !== 'success'
    )
      return []

    const groupTransactionsByCategoryId = _.groupBy(
      transactions.map((transaction) => ({
        ...transaction,
        name: transaction.description,
        [`offset|${transaction.offset}|amount`]: transaction.signed_amount,
      })),
      (transaction) =>
        transaction.transaction_category_id || transaction.transaction_type,
    )

    // _.forEach(groupTransactionsByCategoryId, (value, key) => {
    //   groupTransactionsByCategoryId[key] = value.map((item, index) => {
    //     return {
    //       ...item,
    //       offset: index,
    //     }
    //   })
    // })

    // let rows = [...dataorg].map((item) => {
    //   // item['uid'] = _.uniqueId('vault_')
    //   return item
    // })

    let rows = [...vaultsData]
    // const allCategories = [...incomeCategories, ...expenseCategories]
    const updateCategories = (categories) =>
      categories.map((item) => {
        const processTransactions = (id) => ({
          transactions: groupTransactionsByCategoryId[id] || [],
          offsetData: _.groupBy(
            groupTransactionsByCategoryId[id] || [],
            'offset',
          ),
        })

        if (item.transaction_categories) {
          return {
            ...item,
            transaction_categories: item.transaction_categories.map((itm) => ({
              ...itm,
              ...processTransactions(itm.id),
            })),
          }
        } else {
          return {
            ...item,
            ...processTransactions(item.id),
          }
        }
      })

    const updatedIncomeCategories = updateCategories(incomeCategories)
    const updatedExpenseCategories = updateCategories(expenseCategories)

    rows?.push({
      name: 'Money In',
      entity_type: ENTITY_TYPES.MONEY_IN_HEADER,
      transaction_categories: updatedIncomeCategories,
    })

    rows?.push({
      name: 'Money Out',
      entity_type: ENTITY_TYPES.MONEY_OUT_HEADER,
      transaction_categories: updatedExpenseCategories,
    })

    return rows
  }, [
    vaultsData,
    // periodColumns,
    transactions,
    periodColumnsStatus,
    transactionStatus,
    status,
    incomeCategoriesStatus,
    expenseCategoriesStatus,
    incomeCategories,
    expenseCategories,
  ])

  function getVaultBalanceForOffset(vaultId, offset, isGroup) {
    const cols = periodColumns?.map((col) => col.offset) || []
    let index = cols.indexOf(offset)
    const offsets = cols.slice(0, index + 1)

    if (isGroup) {
      const am = vaultBalance
        .filter((x) => offsets.includes(x.offset) && x.vaultGroupId === vaultId)
        ?.reduce((acc, item) => {
          return acc + item.amount
        }, 0)
      return am
    } else {
      const vb = vaultBalance
        ?.filter((x) => x.vaultId === vaultId && offsets.includes(x.offset))
        ?.reduce((acc, item) => {
          return acc + item.amount
        }, 0)

      return vb
    }
  }

  function hasAnyTransactions(row, offset) {
    if (row.original.entity_type === ENTITY_TYPES.TRANSACTION_CATEGORY) {
      return row.original.transactions.some((item) => item.offset === offset)
    }

    if (row.original.entity_type === ENTITY_TYPES.TRANSACTION_CATEGORY_GROUP) {
      return row.original.transaction_categories.some((item) =>
        item.transactions.some((tr) => tr.offset === offset),
      )
    }

    return true
  }

  function calculateAmount(row, offset) {
    // Vault row calculation
    const isVault = [ENTITY_TYPES.VAULT, ENTITY_TYPES.VAULT_GROUP].includes(
      row.original.entity_type,
    )

    if (isVault) {
      return getVaultBalanceForOffset(
        row.original.id,
        offset,
        row.original.entity_type === ENTITY_TYPES.VAULT_GROUP,
      )
    }

    // Calculate offset amount for MoneyIn MoneyOut Header rows
    const isMoneyInOrOutHeader = [
      ENTITY_TYPES.MONEY_IN_HEADER,
      ENTITY_TYPES.MONEY_OUT_HEADER,
    ].includes(row.original.entity_type)

    if (isMoneyInOrOutHeader) {
      const direction =
        row.original.entity_type === ENTITY_TYPES.MONEY_IN_HEADER
          ? TRANSACTION_DIRECTION.MONEY_IN
          : TRANSACTION_DIRECTION.MONEY_OUT

      return transactions.reduce((acc, item) => {
        return (
          acc +
          (item.offset === offset &&
          item.transaction_type === TRANSACTION_TYPES.STANDARD &&
          item.direction === direction
            ? item.signed_amount
            : 0)
        )
      }, 0)
    }

    if (row.original.entity_type === ENTITY_TYPES.TRANSACTION_CATEGORY) {
      const val =
        row.original.transactions?.reduce((acc, item) => {
          return acc + (offset === item.offset ? item.signed_amount : 0)
        }, 0) ?? 0

      // transactionCategorySum[offset] = val
      return val
    }

    if (row.original.entity_type === ENTITY_TYPES.TRANSACTION_CATEGORY_GROUP) {
      const val = row.original?.transaction_categories?.reduce((acc, item) => {
        const s = item?.offsetData[offset]?.reduce((t, tr) => {
          return t + (tr?.signed_amount || 0)
        }, 0)

        return acc + (s || 0)
      }, 0)
      return val
    }

    return 'n0'
  }

  const getOffsetSum = useCallback(
    (offset) => {
      const cols = periodColumns?.map((col) => col.offset) || []
      let index = cols.indexOf(offset)
      const offsets = cols.slice(0, index + 1)

      return vaultBalance
        .filter((x) => offsets.includes(x.offset))
        ?.reduce((acc, item) => {
          return acc + item.amount
        }, 0)
    },
    [periodColumns, vaultBalance],
  )

  const columnHelper = createColumnHelper()
  const cols = periodColumns?.map((col) => {
    return columnHelper.accessor(`offset-${col.offset}-val`, {
      header: () => {
        const offsetSum = getOffsetSum(col.offset)
        return (
          <ColumnHeader
            className={`w-[124px]--- group -mx-4 flex h-full min-w-[156px] items-center bg-gray-low px-4  py-2 text-txt-secondary data-[state=negative]:bg-yellow-lowest data-[state=thisweek]:bg-accent-lowest data-[state=thisweek]:text-txt-accent ${col.offset === 0 ? 'current-period' : ''}`}
            data-state={
              col.offset === 0
                ? 'thisweek'
                : offsetSum < 0
                  ? 'negative'
                  : 'default'
            }
          >
            <div className="flex w-full flex-col gap-1 text-right">
              <div className="flex justify-between group-data-[state=thisweek]:text-txt-accent">
                <div className="flex items-center justify-center rounded-full bg-gray-tr-12  px-1.5 py-[0.125rem] text-xs text-txt-primary group-data-[state=thisweek]:bg-accent-tr-24 group-data-[state=thisweek]:text-txt-accent">
                  <PlayIcon className="hidden size-3 text-txt-accent group-data-[state=thisweek]:block" />{' '}
                  <span>{col.number}</span>
                </div>
                <span>{formatDate(new Date(col.start), 'd-MMM yy')}</span>
              </div>
              <p className="text-txt-primary">{formatter(offsetSum)}</p>
            </div>
          </ColumnHeader>
        )
      },
      cell: (info) => {
        let amount = calculateAmount(info.row, col.offset)
        const item = info.row.original
        if (
          item.entity_type === ENTITY_TYPES.MONEY_OUT_HEADER ||
          ((item.entity_type === ENTITY_TYPES.TRANSACTION_CATEGORY_GROUP ||
            item.entity_type === ENTITY_TYPES.TRANSACTION_CATEGORY) &&
            item.direction === -1)
        ) {
          amount = amount === 0 ? amount : amount * -1
        }
        return (
          <div className="tw-grid">
            {[ENTITY_TYPES.TRANSACTION_CATEGORY, ENTITY_TYPES.VAULT].includes(
              info.row.original.entity_type,
            ) && <ClickableCell col={col} cellContext={info} />}
            <div
              data-negative={
                amount < 0 &&
                [ENTITY_TYPES.VAULT, ENTITY_TYPES.VAULT_GROUP].includes(
                  info.row.original.entity_type,
                )
                  ? true
                  : undefined
              }
              className="tw-truncate text-right"
            >
              {hasAnyTransactions(info.row, col.offset)
                ? formatter(amount)
                : ''}
            </div>
          </div>
        )
      },
    })
  })

  cols?.unshift(
    columnHelper.accessor('name', {
      header: () => (
        <ColumnHeader className="flex w-[280px] items-center justify-between px-1">
          <span>My Money</span>
          <DropdownMenu>
            <DropdownMenuTrigger>
              <Button iconOnly type="button" variant="ghost">
                <PlusCircleIcon />
              </Button>
            </DropdownMenuTrigger>
            <DropdownMenuContent className="w-[220px]">
              <DropdownMenuItem>
                <Button
                  variant="ghost"
                  onClick={
                    () => navigate('vaults/new')
                    // open({
                    //   name: NON_MODAL_WINDOW_TYPE.VAULT,
                    // })
                  }
                  // onClick={() => handleNonModalWindow('vault')}
                >
                  <CurrencyDollarIcon />
                  <ButtonText>Add New Vault</ButtonText>
                </Button>
              </DropdownMenuItem>
              <DropdownMenuItem>
                <Button
                  variant="ghost"
                  onClick={() => navigate('vaults/groups/new')}
                >
                  <FolderIcon />
                  <ButtonText>Add group for vault</ButtonText>
                </Button>
              </DropdownMenuItem>
            </DropdownMenuContent>
          </DropdownMenu>
        </ColumnHeader>
      ),
      cell: (info) => {
        const isGroupRow = [
          ENTITY_TYPES.VAULT_GROUP,
          ENTITY_TYPES.MONEY_IN_HEADER,
          ENTITY_TYPES.MONEY_OUT_HEADER,
          ENTITY_TYPES.TRANSACTION_CATEGORY_GROUP,
        ].includes(info.row.original?.entity_type)

        return (
          <div className="group/cell-- -ml-4-- grid-cols-[1.75rem,1fr]-- grid gap-1 px-1">
            {/* <div className="opacity-0 group-hover/cell:opacity-100">
            <RowDragHandleCell
              key={info.row.id}
              rowId={info.row.id}
              rowItem={info.row.original}
            />
          </div> */}
            {/* {info.cell.column.getIsFirstColumn() ? 'first' : 'not first'} */}
            {/* {info.row.getToggleExpandedHandler()} */}
            {/* <button type="button" onClick={() => info.row.toggleExpanded(false)}>
            xx
          </button> */}
            {/* {info.row.id} */}
            <div
              className={
                { 1: 'pl-6', 2: 'pl-9', 3: 'pl-12', 4: 'pl-15' }[info.row.depth]
              }
            >
              <div className="truncate---- flex items-center justify-between gap-1">
                <div
                  data-canexpand={isGroupRow || undefined}
                  data-archived={
                    info.row.original?.is_archive ||
                    info.row.original?.is_archived
                      ? true
                      : undefined
                  }
                  className="flex gap-2 data-[canexpand]:grid data-[canexpand]:grid-cols-[1rem,1fr] [&>*]:data-[archived]:opacity-50"
                >
                  {info.row.original?.entity_type ===
                  ENTITY_TYPES.MONEY_IN_HEADER ? (
                    <ArrowUpRightIcon className="text-txt-success" />
                  ) : info.row.original?.entity_type ===
                    ENTITY_TYPES.MONEY_OUT_HEADER ? (
                    <ArrowDownRightIcon className="text-txt-purple" />
                  ) : isGroupRow && info.row.original?.is_archive ? (
                    <ArchiveBoxIcon className="text-txt-secondary" />
                  ) : isGroupRow ? (
                    <FolderIcon className="mt-[1px] size-4 text-txt-accent" />
                  ) : !!info.row.original?.is_default_for_income &&
                    !!info.row.original?.is_default_for_expense ? (
                    <div>
                      <svg
                        className="size-4"
                        width="16"
                        height="16"
                        viewBox="0 0 16 16"
                        fill="none"
                        xmlns="http://www.w3.org/2000/svg"
                      >
                        <path
                          d="M2.21967 4.46967C1.92678 4.76256 1.92678 5.23744 2.21967 5.53033C2.51256 5.82322 2.98744 5.82322 3.28033 5.53033L4.25 4.56066L4.25 10.25C4.25 10.6642 4.58579 11 5 11C5.41421 11 5.75 10.6642 5.75 10.25L5.75 4.56066L6.71967 5.53033C7.01256 5.82322 7.48744 5.82322 7.78033 5.53033C8.07322 5.23744 8.07322 4.76256 7.78033 4.46967L5.53033 2.21967C5.23744 1.92678 4.76256 1.92678 4.46967 2.21967L2.21967 4.46967Z"
                          fill="#2DA44E"
                        />
                        <path
                          d="M13.7803 11.5303C14.0732 11.2374 14.0732 10.7626 13.7803 10.4697C13.4874 10.1768 13.0126 10.1768 12.7197 10.4697L11.75 11.4393V5.75C11.75 5.33579 11.4142 5 11 5C10.5858 5 10.25 5.33579 10.25 5.75V11.4393L9.28033 10.4697C8.98744 10.1768 8.51256 10.1768 8.21967 10.4697C7.92678 10.7626 7.92678 11.2374 8.21967 11.5303L10.4697 13.7803C10.7626 14.0732 11.2374 14.0732 11.5303 13.7803L13.7803 11.5303Z"
                          fill="#8250DF"
                        />
                      </svg>
                    </div>
                  ) : info.row.original?.is_default_for_income ? (
                    <div>
                      <ArrowUpRightIcon className="size-4 text-txt-success" />
                    </div>
                  ) : info.row.original?.is_default_for_expense ? (
                    <div>
                      <ArrowDownRightIcon className="size-4 text-txt-purple" />
                    </div>
                  ) : null}
                  {/* START LABEL */}
                  <div className="inline-grid">
                    <TruncatedLabel text={info.getValue()} />
                    {info.row.original?.description && (
                      <>
                        <TruncatedLabel
                          className="text-xs text-txt-secondary"
                          text={info.row.original?.description}
                        />
                      </>
                    )}
                  </div>
                  {/* END LABEL */}
                </div>

                <div className="flex items-center gap-4">
                  {/* Add Category */}
                  <ConditionalRender
                    condition={[
                      ENTITY_TYPES.MONEY_IN_HEADER,
                      ENTITY_TYPES.MONEY_OUT_HEADER,
                    ].includes(info.row.original?.entity_type)}
                  >
                    <DropdownMenu>
                      <DropdownMenuTrigger asChild>
                        <Button iconOnly variant="ghost">
                          <PlusCircleIcon />
                        </Button>
                      </DropdownMenuTrigger>
                      <DropdownMenuContent>
                        <DropdownMenuItem>
                          {info.row.original.entity_type ===
                          ENTITY_TYPES.MONEY_IN_HEADER ? (
                            <Button
                              variant="ghost"
                              onClick={
                                () => navigate('/categories/new?type=in')
                                // open({
                                //   name: NON_MODAL_WINDOW_TYPE.TRANSACTION_CATEGORY_INCOME,
                                // })
                              }
                            >
                              <ArrowUpRightIcon />
                              <ButtonText>Add Money In Category</ButtonText>
                            </Button>
                          ) : (
                            <Button
                              variant="ghost"
                              onClick={
                                () => navigate('/categories/new?type=out')
                                // open({
                                //   name: NON_MODAL_WINDOW_TYPE.TRANSACTION_CATEGORY_EXPENSE,
                                // })
                              }
                            >
                              <ArrowDownRightIcon />
                              <ButtonText>Add Money Out Category</ButtonText>
                            </Button>
                          )}
                        </DropdownMenuItem>
                        <DropdownMenuItem>
                          <Button
                            variant="ghost"
                            onClick={() =>
                              navigate(
                                `/categories/groups/new?type=${info.row.original.entity_type === 'money_in_header' ? 'in' : 'out'}`,
                              )
                            }
                          >
                            <FolderPlusIcon />
                            <ButtonText>Add New Group</ButtonText>
                          </Button>
                        </DropdownMenuItem>
                      </DropdownMenuContent>
                    </DropdownMenu>
                  </ConditionalRender>

                  {info.row.original?.entity_type === 'vault' &&
                    info.row.original?.is_archived !== 0 && (
                      <UnArchiveVault id={info.row.original?.id} />
                    )}

                  {info.row.original?.entity_type === 'transaction_category' &&
                    info.row.original?.is_archived !== 0 && (
                      <UnArchiveTransactionCatrgory
                        id={info.row.original?.id}
                      />
                    )}

                  {isGroupRow &&
                    ![
                      ENTITY_TYPES.MONEY_IN_HEADER,
                      ENTITY_TYPES.MONEY_OUT_HEADER,
                    ].includes(info.row.original?.entity_type) && (
                      <div className="flex size-5 items-center justify-center rounded-full bg-gray-tr-08 text-xs text-txt-secondary">
                        <span>{info.row.subRows.length}</span>
                      </div>
                    )}

                  {/* START More action button */}
                  {info.row.original?.is_archive ||
                  info.row.original?.is_archived ? null : (
                    <div className="">
                      <DropdownMenu modal={false}>
                        <DropdownMenuTrigger asChild>
                          <Button iconOnly variant="ghost">
                            <EllipsisHorizontalIcon />
                          </Button>
                        </DropdownMenuTrigger>
                        <DropdownMenuContent>
                          <DropdownMenuItem>
                            <Button
                              variant="ghost"
                              onClick={() =>
                                open({
                                  name: onEdit(info.row.original),
                                })
                              }
                            >
                              <PencilSquareIcon />
                              <ButtonText>Edit</ButtonText>
                            </Button>
                          </DropdownMenuItem>
                          {info.row.original.entity_type === 'vault' && (
                            <>
                              {info.row.original?.is_default_for_expense ||
                              info.row.original?.is_default_for_income ? (
                                <>
                                  {info.row.original?.is_default_for_expense &&
                                  info.row.original
                                    ?.is_default_for_income ? null : (
                                    <DropdownMenuItem>
                                      <Button
                                        variant="ghost"
                                        onClick={() => {
                                          markDefaultForIncome(
                                            info.row.original.id,
                                          )
                                          markDefaultForExpense(
                                            info.row.original.id,
                                          )
                                        }}
                                      >
                                        <ArrowsUpDownIcon className="size-4 text-green-500" />
                                        <ButtonText>
                                          Set as Main Vault for All
                                        </ButtonText>
                                      </Button>
                                    </DropdownMenuItem>
                                  )}
                                </>
                              ) : (
                                <DropdownMenuSub>
                                  <DropdownMenuSubTrigger className="pl-3">
                                    <div className="flex items-center gap-2">
                                      <FlagIcon className="size-4 text-txt-secondary" />
                                      <ButtonText>
                                        Set as Main Vault for
                                      </ButtonText>
                                    </div>
                                  </DropdownMenuSubTrigger>
                                  <DropdownMenuPortal>
                                    <DropdownMenuSubContent>
                                      <DropdownMenuItem
                                        onClick={() =>
                                          markDefaultForIncome(
                                            info.row.original.id,
                                          )
                                        }
                                      >
                                        <div className="flex items-center gap-2">
                                          <ArrowUpRightIcon className="size-4 text-green-500" />
                                          <ButtonText>Money In</ButtonText>
                                        </div>
                                      </DropdownMenuItem>
                                      <DropdownMenuItem
                                        onClick={() =>
                                          markDefaultForExpense(
                                            info.row.original.id,
                                          )
                                        }
                                      >
                                        <div className="flex items-center gap-2">
                                          <ArrowDownRightIcon className="size-4 text-txt-purple" />
                                          <ButtonText>Money Out</ButtonText>
                                        </div>
                                      </DropdownMenuItem>
                                      <DropdownMenuItem
                                        onClick={() => {
                                          markDefaultForIncome(
                                            info.row.original.id,
                                          )
                                          markDefaultForExpense(
                                            info.row.original.id,
                                          )
                                        }}
                                      >
                                        <div className="flex items-center gap-2">
                                          <ArrowsUpDownIcon className="size-4 text-green-500" />
                                          <ButtonText>All</ButtonText>
                                        </div>
                                      </DropdownMenuItem>
                                    </DropdownMenuSubContent>
                                  </DropdownMenuPortal>
                                </DropdownMenuSub>
                              )}
                            </>
                          )}

                          {info.row.original.entity_type === 'vault' && (
                            <Button
                              variant="destructiveGhost"
                              onClick={() => onArchiveVault(info.row.original)}
                              className={'w-full justify-start'}
                            >
                              <ArchiveBoxIcon />
                              <ButtonText>Archive</ButtonText>
                            </Button>
                          )}
                          {info.row.original.entity_type ===
                            'transaction_category' && (
                            <ArchiveEmptyCategory
                              category={info.row.original}
                            />
                            // <Button
                            //   variant="destructiveGhost"
                            //   onClick={() =>
                            //     onArchiveCategory(info.row.original)
                            //   }
                            //   className={'w-full justify-start'}
                            // >
                            //   <ArchiveBoxIcon />
                            //   <ButtonText>Archive</ButtonText>
                            // </Button>
                          )}
                        </DropdownMenuContent>
                      </DropdownMenu>
                    </div>
                  )}
                  {/* END More action button */}

                  {isGroupRow && info.row.getIsExpanded() ? (
                    <Button
                      iconOnly
                      variant="ghost"
                      onClick={info.row.getToggleExpandedHandler()}
                    >
                      <ChevronDownIcon />
                    </Button>
                  ) : null}
                  {isGroupRow && !info.row.getIsExpanded() ? (
                    <Button
                      iconOnly
                      variant="ghost"
                      onClick={info.row.getToggleExpandedHandler()}
                    >
                      <ChevronRightIcon />
                    </Button>
                  ) : null}
                </div>
              </div>
            </div>
          </div>
        )
      },
    }),
  )

  const table = useReactTable({
    data: data ?? [],
    columns: cols ?? [],
    getCoreRowModel: getCoreRowModel(),
    getExpandedRowModel: getExpandedRowModel(),
    getRowId: (row) => {
      return row.entity_type
        ? `${row.entity_type}-${row.id ?? 0}-${row.direction ?? 0}`
        : undefined
    },
    // state: {
    //   columnPinning: {
    //     left: ['id'],
    //   },
    // },
    initialState: {
      columnPinning: {
        left: ['name'],
      },
      // expanded: true,
    },
    getSubRows: (row) =>
      row.vaults || row.subRows || row.transaction_categories,
    // row.transactions,
  })

  const isLoading = [
    status,
    periodColumnsStatus,
    transactionStatus,
    incomeCategoriesStatus,
    expenseCategoriesStatus,
  ].some((s) => s === 'pending')

  if (isLoading) return <div>Loading...</div>

  return <DataTable table={table} className="h-full overflow-auto" />
}
